// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import displayUser from "@insite/client-framework/Store/Pages/UserSetup/Handlers/DisplayUser";
import { chain, DispatchCompleteLoadAccount } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SaveUser";

/**
 * XNG-Changes
 * https://xngage.atlassian.net/browse/BG-2874?focusedCommentId=349021
 * Reloading is required after saving because `allowBillTrustAccess` may update the user's role.
 */
const XngLoadCurrentAccount: typeof DispatchCompleteLoadAccount = props => {
    if (!props.apiResult.successful) {
        return;
    }

    const location = getLocation(props.getState());
    let userId;
    if (location && location.search) {
        const parsedQuery = parseQueryString<{ userId: string }>(location.search);
        userId = parsedQuery.userId;
    }

    if (userId) {
        props.dispatch(displayUser({ userId }));
    }
};

addToChainAfter(chain, DispatchCompleteLoadAccount, XngLoadCurrentAccount);
